var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "flex-direction": "column" } },
    [
      _c(
        "div",
        {
          staticClass: "red",
          staticStyle: { display: "flex", "flex-direction": "column" }
        },
        [
          _c("el-input", {
            attrs: {
              value:
                _vm.cargoDoc.requestReleaseState === 0
                  ? _vm.$t("SeaExport.NotApplying")
                  : _vm.$t("SeaExport.Requested"),
              disabled: true
            }
          }),
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.job.jointMasterHBLUuid
                  ? _vm.$t("SeaExport.TicketHasMerged")
                  : _vm.job.typeHBL === _vm.BillType.SPLIT_BILL_TYPE.code
                  ? _vm.$t("SeaExport.TicketHasSplit")
                  : ""
              )
            )
          ])
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "el-checkbox",
            {
              staticStyle: { "margin-right": "6px" },
              attrs: { value: _vm.cargoDoc.releaseReview === 1, disabled: true }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.DataSent")))]
          ),
          _c(
            "el-checkbox",
            {
              staticStyle: { "margin-right": "6px" },
              attrs: { value: _vm.cargoDoc.payable, disabled: true }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Completed")))]
          ),
          _c(
            "el-checkbox",
            {
              staticStyle: { "margin-right": "0px" },
              attrs: { value: _vm.cargoDoc.withhold, disabled: true }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.CargoDetention")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }